import type { ConsumerData } from '@/services/consumerService'
import type { SendConsumer } from './RecipientRow'

const text = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : ''

/**
 * The name for the send dialog. The Gateway fills the flat payerName only for
 * some consumers; for the others it comes as a resource entry of the billing
 * record. The contacts are not read here: a send reaches the notification
 * targets, which the dialog loads on its own.
 */
export const toSendConsumer = (consumer: ConsumerData): SendConsumer => ({
  name:
    text(consumer.payerName) ||
    text(consumer.resources?.find(r => r.key === 'payer_name')?.value),
})
